var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { container } from 'tsyringe';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import store from 'store/core';
import Permissions from 'common/support/Permissions';
var NavigationService = /** @class */ (function () {
    function NavigationService() {
        this.permissions = container.resolve(Permissions);
        this.auth = container.resolve(Authenticator);
    }
    NavigationService.prototype.isCompanyInToken = function (currentCompanyId) {
        return this.auth.getCompaniesIds().some(function (companyId) { return companyId === currentCompanyId; });
    };
    NavigationService.prototype.hasCompanyIdParam = function (path) {
        var hasCompanyIdParam = new RegExp('^\\/c\\/\\d+');
        return hasCompanyIdParam.test(path);
    };
    NavigationService.prototype.stripAuthFromRoute = function (route) {
        var strippedQuery = __assign({}, route.query);
        delete strippedQuery.token;
        delete strippedQuery['access-token'];
        delete strippedQuery.company_id;
        return { query: strippedQuery };
    };
    NavigationService.prototype.authorizeRouteGuard = function (currentCompanyId, to, next) {
        return __awaiter(this, void 0, void 0, function () {
            var routeHasAuthParams, query, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        routeHasAuthParams = to.query['access-token'] || to.query.company_id;
                        if (to.name.startsWith('Error')) {
                            return [2 /*return*/, next()];
                        }
                        if (routeHasAuthParams) {
                            query = this.stripAuthFromRoute(to).query;
                            return [2 /*return*/, next(__assign(__assign({}, to), { query: query }))];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!store.state.authChecked) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.auth.check()];
                    case 2:
                        _a.sent();
                        store.commit('authChecked', true);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        return [2 /*return*/, this.auth.redirectToLogin()];
                    case 5:
                        if (this.permissions.isAdmin) {
                            return [2 /*return*/];
                        }
                        if (!!this.auth.permissionData.companies.includes(currentCompanyId)) return [3 /*break*/, 9];
                        if (!this.auth.getRefreshToken()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.auth.refreshToken()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [4 /*yield*/, this.auth.fetchPermissions()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        if (this.auth.permissionData.companies.includes(currentCompanyId)) {
                            return [2 /*return*/];
                        }
                        if (this.auth.permissionData.companies.length !== 1) {
                            return [2 /*return*/, next({ name: 'Error.403' })];
                        }
                        if (currentCompanyId.toString() !== this.auth.permissionData.companies[0].toString()) {
                            this.auth.selectCompany(this.auth.permissionData.companies[0]);
                            return [2 /*return*/, next({
                                    path: "/c/" + this.auth.permissionData.companies[0],
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return NavigationService;
}());
export default NavigationService;
